module.exports = __webpack_public_path__ + "static/img/select-pic.41cddb55.jpg";